import BsHeader from './index.vue'
export default BsHeader